module.exports = __webpack_public_path__ + "static/media/catalogo.08ac7d33.svg";